import AgGridPriceMatrix from "./AgGridPriceMatrix";

export default AgGridPriceMatrix;



// WEBPACK FOOTER //
// ./src/components/AgGridPriceMatrix/index.js